const EditionType = `
  id
  description
  code
`;

export default EditionType;
